import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import classes from './Drawer.module.scss'

const ICON_CLASSES = {
  plain: classes.iconPlain,
  avatar: classes.iconAvatar,
  circle: classes.iconCircle,
}

const DrawerCard = ({
  icon, iconVariant = 'plain', image, label, note, trailing, highlight = false, danger = false, to, href, onClick, onRemove, disabled = false,
}) => {
  const { t } = useTranslation()
  const Tag = to ? Link : href ? 'a' : onClick ? 'button' : 'div'

  return (
    <Tag
      className={classNames(classes.card, 'd-flex align-items-center w-100 text-left', {
        [classes.cardHighlight]: highlight, [classes.cardDanger]: danger, [classes.cardClickable]: !!onClick || !!to || !!href,
      })}
      to={to}
      href={href}
      target={to ? '_blank' : undefined}
      rel={to ? 'noopener noreferrer' : undefined}
      onClick={onClick}
      disabled={onClick ? disabled : undefined}
    >
      {(image || icon) && (
        <span
          className={classNames(classes.cardIcon, ICON_CLASSES[iconVariant], 'd-inline-flex align-items-center justify-content-center flex-shrink-0')}
        >
          {image ? <img src={image} alt='' className={`${classes.cardImage} w-100 h-100`} /> : icon}
        </span>
      )}
      <div className={classNames(classes.cardText, 'flex-grow-1')}>
        <div className={classes.cardLabel}>{label}</div>
        {note && <div className={classes.cardNote}>{note}</div>}
      </div>
      {trailing}
      {onRemove && (
        <button className={classes.removeButton} onClick={onRemove} disabled={disabled}>
          {t('common.action.remove')}
        </button>
      )}
    </Tag>
  )
}

DrawerCard.propTypes = {
  icon: PropTypes.node,
  iconVariant: PropTypes.oneOf(['plain', 'avatar', 'circle']),
  image: PropTypes.string,
  label: PropTypes.node.isRequired,
  note: PropTypes.node,
  trailing: PropTypes.node,
  highlight: PropTypes.bool,
  danger: PropTypes.bool,
  to: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  onRemove: PropTypes.func,
  disabled: PropTypes.bool,
}

export default DrawerCard
